import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import snakeCaseKeys from 'snakecase-keys';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../config/abilityContext';
import { createOtherRequestRequest } from '../../../requests/otherRequests';
import { sendAlert } from '../../../actions/utils';
import { SimpleCenteredModal } from '../../../components';
import OtherRequestDataTable from '../../Shared/OtherRequest/OtherRequestDataTable';
import OtherRequestForm from '../../Shared/OtherRequest/OtherRequestForm';
import columns from './Columns';

const OtherRequestIndex = ({ employeeId, dispatch }) => {
  const [modalShow, setModalShow] = useState(false);
  const [moreData, setMoreData] = useState(false);
  const [currentOtherRequest, setCurrentOtherRequest] = useState({});
  const [newOtherRequest, setNewOtherRequest] = useState(false);
  const ability = useAbility(AbilityContext);

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleSuccessRequest = () => {
    dispatch(sendAlert({ kind: 'success', message: 'Solicitud creada correctamente' }));
    setMoreData(!moreData);
    handleModalClose();
  };

  const handleCreateRequest = (otherRequest, setSubmitting) => {
    const myParams = snakeCaseKeys(otherRequest);

    createOtherRequestRequest({
      dispatch,
      params: myParams,
      successCallback: handleSuccessRequest,
      callback: () => setSubmitting(false)
    });
  };

  const handleFailureRequest = error => {
    const { response } = error;
    handleModalClose();
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
  };

  const handleUpdateModal = otherRequest => {
    setNewOtherRequest(false);
    setCurrentOtherRequest(otherRequest);
    setModalShow(true);
  };

  const handleCreateModal = () => {
    const newCurrentOtherRequest = {
      employeeId,
      otherRequestTypeId: '',
      startDate: '',
      endDate: '',
      additional: '',
      reason: ''
    };
    setCurrentOtherRequest(newCurrentOtherRequest);
    setNewOtherRequest(true);
    setModalShow(true);
  };

  return (
    <Row className="mt-1 mb-3">
      <Col>
        <Row className="border-responsive">
          <Col xs={{ offset: 6 }} md={{ span: 3, offset: 9 }}>
            {ability.can('create', 'OtherRequest') && (
              <Button variant="primary" block onClick={handleCreateModal}>
                Nuevo
              </Button>
            )}

            <SimpleCenteredModal
              title="Nueva Solicitud"
              body={
                <OtherRequestForm
                  action={newOtherRequest ? 'new' : 'edit'}
                  formRequest={handleCreateRequest}
                  handleModalClose={() => handleModalClose()}
                  otherRequest={{ ...currentOtherRequest, rrhh: false }}
                  rrhh={false}
                />
              }
              show={modalShow}
              onHide={handleModalClose}
            />
          </Col>
        </Row>
        <OtherRequestDataTable
          columns={columns}
          moreData={moreData}
          setMoreData={() => setMoreData(!moreData)}
          customParams={{ filter_employee: employeeId }}
          handleUpdateModal={handleUpdateModal}
          handleFailureRequest={handleFailureRequest}
          employee
        />
      </Col>
    </Row>
  );
};

const mapStateToProps = state => {
  const employeeId = state.auth.currentEmployee;
  return { employeeId };
};

export default connect(mapStateToProps)(OtherRequestIndex);